<template>
  <ContentCard title="零星采购">
    <ProjectListBody
      :dataSource="dataSource"
      :TabList="TabList"
      :getData="getData"
      :openNoticePage="openNoticePage"
      :goMore="goMore"
      >
      <template v-slot:default="{ item }">
        <div class="body-title">{{ item.title }}</div>
        <div style="width: 120px; text-align: center;">{{ item.createdDate ? moment(item.createdDate).format('YYYY-MM-DD') : '-' }}</div>
      </template>
    </ProjectListBody>
  </ContentCard>
</template>

<script>
import moment from 'moment'
import { store } from '@ice/stark-data'
import { lxSelfBiddingNoticeTypeList, getFilter } from '@/utils/config'

import ContentCard from '@/components/ContentCard'
import ProjectListBody from '@/components/ProjectListBody'
import { noticeGetPaged } from '@/api/siteserver'

export default {
	name: "SystemNotice",
  components: { ContentCard, ProjectListBody },
  data() {
    return {
      moment,
      TabList: lxSelfBiddingNoticeTypeList,
      dataSource: []
    }
  },
  methods: {
    async getData(currentTab) {
			try {
        let filter = getFilter(currentTab)
        const { success, result } = await noticeGetPaged({
          filter: filter,
          order: 'createdDate desc',
          pageNum: 1,
          pageSize: 5
        })
				if(success) {
          this.dataSource = result.items
        }
        // console.log(this.dataSource, 'this.dataSource');
			} catch(err) {
				console.error(err);
			}
    },
    openNoticePage(item) {
      const url = this.$router.resolve({ path: '/noticeContent', query: { nId: item.id }}).href
      window.open(url, '_blank')
		},
    goMore(currentTab) {
      store.set('nType', currentTab)
			this.$router.push({ name: 'purchaseInfo' })
    }
  }
};
</script>

<style lang="less" scoped>
.body-title {
  width: calc(100% - 120px);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>
